import store from "@/store";
import CommonHelper from "@/scripts/helpers/common.helper";
import CheckoutSimplifiedQuestionService from "@/scripts/services/checkoutSimplifiedQuestion.service";

const service = new CheckoutSimplifiedQuestionService();

// Abre a modal de confirmacao de dados quando o usuario logado ainda tem pergunta obrigatoria
// (CheckoutSimplifiedQuestion com ShowOnPersonInfoModal + IsRequired) sem resposta NA CAMPANHA.
// Usa SHOW_PERSON_INFO_NOW, que passa por cima da trava do localStorage "showPersonInfoUsers":
// a trava continua valendo para quem nao tem pendencia (o back responde false e nada acontece).
//
// campaignId: opcional; sem ele o back usa a campanha do subdominio.
// showMessage: avisa o usuario (usado no checkout, onde a doacao e interrompida).
// Retorna true quando ha pendencia (a modal foi aberta).
export async function openPersonInfoIfPending({ campaignId = 0, showMessage = false } = {}) {
  if (!store.getters.logged || !CommonHelper.getSubdomain()) return false;

  let pending = false;
  try {
    pending = !!(await service.hasMyPendingPersonInfoQuestions(campaignId));
  } catch (e) {
    // Falha na consulta nao pode travar navegacao nem doacao.
    return false;
  }

  if (pending) {
    if (showMessage) {
      CommonHelper.swal("Antes de concluir a doação, responda as perguntas obrigatórias do cadastro.");
    }
    store.commit("SHOW_PERSON_INFO_NOW");
  }
  return pending;
}
